import { isHttpUrl, normalizeHttpUrl } from "../../../../helpers/externalUrl";
import type { ClientSitePatchBody } from "../SiteEditPage";

const emptyToNull = (value: string | null | undefined): string | null =>
  value?.trim() || null;

const normalizeOptionalPair = (
  first: string | null | undefined,
  second: string | null | undefined
): [string | null, string | null] => {
  const normalizedFirst = emptyToNull(first);
  const normalizedSecond = emptyToNull(second);
  return normalizedFirst && normalizedSecond
    ? [normalizedFirst, normalizedSecond]
    : [null, null];
};

export const prepareSiteFormPayload = (
  form: ClientSitePatchBody
): ClientSitePatchBody => {
  const [secondaryCta, secondaryCtaLink] = normalizeOptionalPair(
    form.hero?.secondary_cta,
    form.hero?.secondary_cta_link
  );
  const hasPrimaryCta =
    form.hero && ("cta" in form.hero || "cta_link" in form.hero);
  const [primaryCta, primaryCtaLink] = normalizeOptionalPair(
    form.hero?.cta,
    form.hero?.cta_link
  );
  const hero = form.hero
    ? {
        ...form.hero,
        ...(hasPrimaryCta && {
          cta: primaryCta,
          cta_link: primaryCtaLink,
        }),
        secondary_cta: secondaryCta,
        secondary_cta_link: secondaryCtaLink
          ? normalizeHttpUrl(secondaryCtaLink)
          : null,
      }
    : undefined;
  const teams = form.teams
    ? {
        ...form.teams,
        items: form.teams.items?.map((member) => ({
          ...member,
          social_links: member.social_links
            ?.map((link) => ({
              ...link,
              url: normalizeHttpUrl(link.url),
            }))
            .filter((link) => isHttpUrl(link.url)),
        })),
      }
    : undefined;
  const faq = form.faq
    ? {
        ...form.faq,
        items: form.faq.items
          ?.filter((item) => item.question?.trim() && item.answer?.trim())
          .map((item) => ({
            ...item,
            question: item.question?.trim(),
            answer: item.answer?.trim(),
          })),
      }
    : undefined;

  return {
    ...form,
    ...(hero && { hero }),
    ...(teams && { teams }),
    ...(faq && { faq }),
  };
};
